import React from 'react';
import UIKitModal from './Modal';
import UIKitButton from './Button';

interface UIKitConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string | React.ReactNode;
  submitText?: string;
  cancelText?: string;
}

const UIKitConfirmModal: React.FC<UIKitConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm',
  message = '',
  submitText = 'Yes',
  cancelText = 'No',
}) => (
  <UIKitModal
    size="sm"
    open={open}
    onClose={onClose}
    title={title}
    actions={
      <>
        <UIKitButton text={cancelText} variant="link" color="secondary" onClick={onClose} />
        <UIKitButton
          text={submitText}
          variant="flat"
          color="primary"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        />
      </>
    }
  >
    {message}
  </UIKitModal>
);

export default UIKitConfirmModal;
